import React from 'react'
import {
  Locked,
  OverflowMenuHorizontal,
  OverflowMenuVertical,
} from '@carbon/icons-react'

import { Restart } from '@carbon/icons-react'
import { getImagePath } from '../utils/getBrowsersImages'
import { getPermissionImagePath } from '../utils/getBrowsersPermissionImages'
import { getStepThreeMobileImagePath } from '../utils/getBrowsersStepThreeMobile'
import { getStepFourMobileImagePath } from '../utils/getBrowsersStepFourMobile'
import { getStepFiveMobileImagePath } from '../utils/getBrowsersStepFiveMobile'
import { getStepSixMobileImagePath } from '../utils/getBrowsersStepSixMobile'
import { Trans } from 'react-i18next'
import { ReloadButton } from './ReloadButton'
interface MobileContentProps {
  browser: string
  os: string
  brand: string
  token: string
  language: string
  startDate: string
  endDate: string
  meetingNumber: string
  password: string
}

const MobileContent: React.FC<MobileContentProps> = ({
  browser,
  os,
  brand,
  token,
  language,
  startDate,
  endDate,
  meetingNumber,
  password,
}) => {
  const resolvedImagePath = getImagePath(browser, os)
  const permissionImagePath = getPermissionImagePath(browser, os)
  const stepThreeImagePath = getStepThreeMobileImagePath(browser, os)
  const stepFourImagePath = getStepFourMobileImagePath(browser, os)
  const stepFiveImagePath = getStepFiveMobileImagePath(browser, os)
  const stepSixImagePath = getStepSixMobileImagePath(browser, os)

  const mobileContentMap: { [key: string]: JSX.Element } = {
    android_chrome: (
      <>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p className="flex items-center gap-1">
            <Trans
              i18nKey="zoom.instructions.android.chrome.stepOneA"
              components={{
                icon: <Locked className="mt-1 w-6 h-6" />,
              }}
            />
          </p>
          <img src={resolvedImagePath} alt="mobile-Android-Chrome" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.chrome.stepTwo" />
          </p>
          <img
            src={permissionImagePath}
            alt="mobile-Android-Chrome"
            className="w-[100px] h-[104px]"
          />
        </div>
        <p>
          <Trans i18nKey="zoom.instructions.android.chrome.stepThree" />
        </p>
        <p>
          <Trans i18nKey="zoom.instructions.android.chrome.stepThreeB" />
        </p>
        <p>
          <Trans i18nKey="zoom.instructions.android.chrome.stepFour" />
        </p>
        <ReloadButton
          brand={brand}
          translationKey="zoom.instructions.android.chrome.reloadButton"
          startDate={startDate}
          endDate={endDate}
          language={language}
          token={token}
        />
      </>
    ),
    android_firefox: (
      <>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p className="flex items-center gap-1">
            <Trans
              i18nKey="zoom.instructions.android.firefox.stepOne"
              components={{
                icon: <OverflowMenuVertical className="mt-1 w-6 h-6" />,
              }}
            />
          </p>
          <img src={resolvedImagePath} alt="mobile-Android-Firefox" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.firefox.stepTwo" />
          </p>
          <img src={permissionImagePath} alt="mobile-Android-Firefox" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.firefox.stepThree" />
          </p>
          <img src={stepThreeImagePath} alt="mobile-Android-Firefox" />
        </div>
        <p>
          <Trans i18nKey="zoom.instructions.android.firefox.stepFour" />
        </p>
        <ReloadButton
          brand={brand}
          translationKey="zoom.instructions.android.firefox.reloadButton"
          startDate={startDate}
          endDate={endDate}
          language={language}
          token={token}
        />
        <p>5. Si necesitas ayuda, llama al {`{variable teléfono OP}`}</p>
      </>
    ),
    android_edge: (
      <>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p>
            <Trans
              i18nKey="zoom.instructions.android.edge.stepOne"
              components={{
                icon: <Locked className="mt-1 w-6 h-6" />,
              }}
            />
          </p>
          <img src={resolvedImagePath} alt="mobile-Android-Firefox" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.edge.stepTwo" />
          </p>
          <img src={permissionImagePath} alt="mobile-Android-Firefox" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.edge.stepThree" />
          </p>
          <img src={stepThreeImagePath} alt="mobile-Android-Edge" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.edge.stepFour" />
          </p>
          <img src={stepFourImagePath} alt="mobile-Android-Edge" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.edge.stepFive" />
          </p>
          <img src={stepFiveImagePath} alt="mobile-Android-Edge" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p>
            <Trans i18nKey="zoom.instructions.android.edge.stepSix" />
          </p>
          <ReloadButton
            brand={brand}
            translationKey="zoom.instructions.android.edge.reloadButton"
            startDate={startDate}
            endDate={endDate}
            language={language}
            token={token}
          />
        </div>
      </>
    ),
    android_samsung: (
      <>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p>
            <Trans
              i18nKey="zoom.instructions.android.edge.stepOne"
              components={{
                icon: <Locked className="inline-block w-6 h-6" />,
              }}
            />
          </p>
          <img src={resolvedImagePath} alt="mobile-Android-Samsung" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.samsung.stepTwo" />
          </p>
          <img src={permissionImagePath} alt="mobile-Android-Samsung" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans
              i18nKey="zoom.instructions.android.samsung.stepThree"
              components={{
                icon: <Restart className="inline-block w-6 h-6" />,
              }}
            />
          </p>
          <img src={stepThreeImagePath} alt="mobile-Android-Samsung" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.android.samsung.stepFour" />
          </p>
          <img src={stepFourImagePath} alt="mobile-Android-Samsung" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p>
            <Trans i18nKey="zoom.instructions.android.samsung.stepFive" />
          </p>
          <ReloadButton
            brand={brand}
            translationKey="zoom.instructions.android.samsung.reloadButton"
            startDate={startDate}
            endDate={endDate}
            language={language}
            token={token}
          />
        </div>
      </>
    ),
    iphone_safari: (
      <>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p>
            <Trans i18nKey="zoom.instructions.iphone.safari.stepOne" />
          </p>
          <ReloadButton
            brand={brand}
            translationKey="zoom.instructions.iphone.safari.reloadButton"
            startDate={startDate}
            endDate={endDate}
            language={language}
            token={token}
          />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.iphone.safari.stepTwo" />
          </p>
          <img src={permissionImagePath} alt="mobile-IPhone-Safari" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.iphone.safari.stepThree" />
          </p>
          <img src={stepThreeImagePath} alt="mobile-IPhone-Safari" />
        </div>
        <p>
          <Trans i18nKey="zoom.instructions.iphone.safari.stepFour" />
        </p>
        <ReloadButton
          brand={brand}
          translationKey="zoom.instructions.iphone.safari.reloadButton"
          startDate={startDate}
          endDate={endDate}
          language={language}
          token={token}
        />
      </>
    ),
    iphone_chrome: (
      <>
        <div className="flex flex-col gap-4 justify-center items-center ">
          <p>
            <Trans
              i18nKey="zoom.instructions.iphone.chrome.stepOne"
              components={{
                icon: (
                  <OverflowMenuHorizontal className="inline-block w-6 h-6" />
                ),
              }}
            />
          </p>
          <img src={resolvedImagePath} alt="mobile-Android-Chrome" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.iphone.chrome.stepTwo" />
          </p>
          <img src={permissionImagePath} alt="mobile-IPhone-Chrome" />
        </div>
        <div className="flex flex-col gap-4 justify-center items-center">
          <p>
            <Trans i18nKey="zoom.instructions.iphone.chrome.stepThree" />
          </p>
          <img src={stepThreeImagePath} alt="mobile-IPhone-Chrome" />
        </div>
        <p>
          <Trans i18nKey="zoom.instructions.iphone.chrome.stepFour" />
        </p>
        <ReloadButton
          brand={brand}
          translationKey="zoom.instructions.iphone.chrome.reloadButton"
          startDate={startDate}
          endDate={endDate}
          language={language}
          token={token}
        />
      </>
    ),
  }

  return (
    mobileContentMap[`${os}_${browser}`.toLowerCase()] || (
      <p>
        Instrucciones no disponibles para este navegador y sistema operativo.
      </p>
    )
  )
}

export default MobileContent
